import { format } from 'date-fns';

// сумма по строке (по полю)
export const getFactTotalFromField = (matrix, fieldId) => {
  const row = matrix?.[fieldId] ?? [];
  return row.reduce((sum, c) => sum + (Number(c.factExportVolume) || 0), 0);
};

// сумма по столбцу (по элеватору)
export const getFactTotalFromElevator = (matrix, elevatorId) => {
  return Object.values(matrix ?? {}).reduce((sum, row) => {
    const cell = row.find((c) => c.consumerUnloadingGeoZoneIdTo === elevatorId);
    return sum + (Number(cell?.factExportVolume) || 0);
  }, 0);
};

export const formatTimeToHHmm = (isoString) => {
  const date = new Date(isoString);
  return format(date, 'HH:mm');
};

export const getRegNumByVehicleId = (vehicleId, vehicleList) => {
  const truck = vehicleList?.find((t) => t.vehicleId === vehicleId);
  return truck?.regNum || null;
};
